import { values } from '@dokucoach/common-types';
import { CareLevel, CostType, Unit } from '@dokucoach/invoicing-types';
import { bool, mixed, number, object, string } from 'yup';
import { EuroValue } from '../../common';

export type IInvoiceItem = {
  id: string;
  costType: CostType;
  careLevel: CareLevel | null;
  isDeduction: boolean;
  label: string;
  amount: number;
  quantity: number;
  unitName: Unit;
  unitPrice: number;
  additionalInformation?: string | null;
};

export type IInvoiceItemCreate = {
  costType: CostType;
  careLevel?: CareLevel | null;
  isDeduction: boolean;
  label: string;
  amount: number;
  quantity: number;
  unitName: Unit;
  unitPrice: number;
  additionalInformation?: string | null;
};

export const IInvoiceItemCreateSchema = object({
  costType: mixed<CostType>().oneOf(values(CostType)).required(),
  careLevel: mixed<CareLevel>().oneOf(values(CareLevel)).nullable().optional(),
  isDeduction: bool().required(),
  label: string().required(),
  amount: EuroValue.required(),
  quantity: number().min(0.01).required(),
  unitName: mixed<Unit>().oneOf(values(Unit)).required(),
  unitPrice: EuroValue.required(),
  additionalInformation: string().nullable().notRequired(),
});

export type IInvoiceItemUpdate = {
  costType?: CostType;
  careLevel?: CareLevel | null;
  isDeduction?: boolean;
  label?: string;
  amount?: number;
  quantity?: number;
  unitName?: Unit;
  unitPrice?: number;
  additionalInformation?: string | null;
};

export const IInvoiceItemUpdateSchema = object({
  costType: mixed<CostType>().oneOf(values(CostType)).optional(),
  careLevel: mixed<CareLevel>().oneOf(values(CareLevel)).nullable().optional(),
  isDeduction: bool().optional(),
  label: string().optional(),
  amount: EuroValue.optional(),
  quantity: number().min(0.01).optional(),
  unitName: mixed<Unit>().oneOf(values(Unit)).optional(),
  unitPrice: EuroValue.optional(),
  additionalInformation: string().nullable().notRequired(),
});
